import { render, staticRenderFns } from "./CustomerCategoryArticleMobile.vue?vue&type=template&id=8626465a&scoped=true&"
import script from "./CustomerCategoryArticleMobile.vue?vue&type=script&lang=js&"
export * from "./CustomerCategoryArticleMobile.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCategoryArticleMobile.vue?vue&type=style&index=0&id=8626465a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8626465a",
  null
  
)

export default component.exports